import React, { useState } from "react";
import SpaceEmbedCodeDialog from "./SpaceEmbedCodeDialog";
export const SpaceEmbedCodeAction = ({ spaceId, EmbedCodeComponent, onEmbedCodeSuccess, }) => {
    const [openSpaceEmbedCodeDialog, setOpenSpaceEmbedCodeDialog] = useState(false);
    const toggleSpaceEmbedCodeDialog = () => {
        setOpenSpaceEmbedCodeDialog((prevDialogOpenState) => !prevDialogOpenState);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(EmbedCodeComponent, { onEmbedCode: toggleSpaceEmbedCodeDialog }),
        React.createElement(SpaceEmbedCodeDialog, { spaceId: spaceId, onClose: () => {
                toggleSpaceEmbedCodeDialog();
                onEmbedCodeSuccess && onEmbedCodeSuccess();
            }, open: openSpaceEmbedCodeDialog })));
};
export default SpaceEmbedCodeAction;
